import React, {Component} from 'react';
import Table from '../../../../../components/Table';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import AddressFormModal from '../components/AddressFormModal';
import ImportModal from '../components/ImportModal'
import DeleteAddressModal from '../components/DeleteAddressModal';
import AddressDetailModal from '../components/AddressDetailModal';
import './styles.css'
import _ from 'lodash'

class Directory extends Component {
    static contextTypes = {api: PropTypes.object};
    constructor(props){
        super(props);
        this.state = {
            addingAddress:false,
            detailingAddress:false,
            editingAddress:false,
            deletingAddress:false,
            importing:false
        };
        this.loadData = _.debounce(this.loadData, 450);
    }

    loadData = ( tableState )=>{
        this.tableState = tableState;
        if(tableState.filters.tags) tableState.filters['mailerTags.name']=tableState.filters.tags;

        const filters = { ...tableState.filters, 'order[name]':'DESC' };
        this.context.api.emailAddresses.get( tableState.page, tableState.pageSize, '@Class.EmailAddresses.emailAddresses.get', filters )
    };


    openAddAddress = ()=> this.setState({addingAddress:true});

    closeAddAddress = ()=> this.setState({addingAddress:false});

    openImport = ()=> this.setState({importing:true});

    closeImport = () => {
        this.loadData(this.tableState);
        this.setState({importing:false});
    };

    onDetailAddress= (contact)=> this.setState( {detailingAddress:contact} );

    closeDetailAddress = ()=> this.setState({detailingAddress:false});

    onEditAddress = (e)=>{
        e.stopPropagation();
        this.setState( {editingAddress: e.currentTarget.dataset.index} )
    };

    closeEditAddress = ()=> this.setState({editingAddress:false});

    onDeleteAddress = (e)=>{
        e.stopPropagation();
        this.setState( {deletingAddress: e.currentTarget.dataset.index} )
    };

    deleteAddress = ( address )=>{
        this.context.api.emailAddresses.delete( address.id );
        this.closeDeleteAddress();
    };

    closeDeleteAddress = ()=> this.setState({deletingAddress:false});

    tableDefinition =
        [
            {
                name:'Acciones',
                accessor: ( data, index )=>
                    <span>
                        <button className='btn btn-xs btn-primary' data-index={index} onClick = {this.onEditAddress}><i className='ti-pencil'/></button>&nbsp;
                        <button className='btn btn-xs btn-danger' data-index={index} onClick={this.onDeleteAddress}><i className='ti-trash'/></button>
                    </span>
            }, {
                name:'Nombre',
                id:'name',
                filterable:true,
                accessor:'name',
            }, {
                name:'Email',
                id:'email',
                filterable:true,
                accessor:'email'
            }, {
                name:'Grupos de correo',
                id:'tags',
                filterable:true,
                accessor:(address)=>{
                    let tags = '', tagsTooltip = '';
                    for (let i=0; i<address.mailerTags.length; i++){
                        if(tags!==''){
                            if(i<3) tags = tags + ', ' + address.mailerTags[i].name;
                            tagsTooltip = tagsTooltip + ', ' + address.mailerTags[i].name;
                        }
                        else{
                            tags = address.mailerTags[i].name;
                            tagsTooltip = tags;
                        }
                    } if (address.mailerTags[3]) tags = tags + ', ...';
                    return <span data-toggle="tooltip" data-placement="bottom" title={tagsTooltip}>{tags}</span>;
                }
            },
            /*{
                name:'Activo',
                id:'active',
                filterable:true,
                filterComponent:( props )=>{
                    const onChange = (e)=>{
                        props.onChange(e.target.value);
                    };
                    return <select value={props.value} onChange={onChange} >
                        <option value=''>Todos</option>
                        <option value='true'>Activos</option>
                        <option value='false'>Inactivos</option>
                    </select>;
                },
                accessor:(address)=>{
                    if(address.active===true) return "Activo";
                    else return "Inactivo";
                }
            }
            */
        ];

    render(){
        return(
            <div className="container-fluid Directory">
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <h4 className="card-title">Lista de direcciones de correo</h4>
                            </div>
                            <div className="card-content">
                                <div className='buttonContainer'>
                                 </div>
                                <div className='buttonContainer'>
                                    <button className='btn btn-info btn-fill btn-magnify pull-right' onClick={this.openImport}>
                                        <span className='btn-label'>Importar</span>
                                    </button>
                                    <button className='btn btn-success btn-fill btn-magnify pull-right' onClick={this.openAddAddress}>
                                        <span className='btn-label'><i className='ti-plus'/></span>
                                    </button>
                                    <div className='clearfix'/>
                                </div><br/>
                                <Table
                                    paginated
                                    defaultPageSize={50}
                                    rowIdAccessor={'id'}
                                    totalItems={this.props.emailAddressesMeta.totalItems}
                                    loadData={this.loadData}
                                    columns={ this.tableDefinition }
                                    data={this.props.emailAddresses}
                                    trProps = {(contact)=>({onClick:()=>this.onDetailAddress(contact)})}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                {/*  New address Modal */}
                {this.state.addingAddress?
                    <AddressFormModal
                        onHide={this.closeAddAddress}
                    /> :null}
                {/*  Edit address Modal */}
                {this.state.editingAddress?
                    <AddressFormModal
                        onHide={this.closeEditAddress}
                        editing = { this.props.emailAddresses[ this.state.editingAddress ] }
                    /> :null}
                {/* Delete address Modal*/}
                {this.state.deletingAddress?
                    <DeleteAddressModal
                        emailAddress={ this.props.emailAddresses[ this.state.deletingAddress ]}
                        onHide={this.closeDeleteAddress}
                        onConfirm={this.deleteAddress}
                    /> :null}
                {/* Show address detail Modal*/}
                {this.state.detailingAddress?
                    <AddressDetailModal
                        emailAddress={ this.state.detailingAddress }
                        onHide={this.closeDetailAddress}
                    />
                    :null}
                {/*Show import Modal*/}
                {this.state.importing?
                    <ImportModal
                        onHide={this.closeImport}
                    /> :null}
            </div>
        );
    }
}

const mapStateToProps = ( { api: { emailAddresses=[], emailAddressesMeta={} } } )=>{
    return {emailAddresses, emailAddressesMeta}
};

export default connect(mapStateToProps)(Directory);


// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/scenes/MailManager/Directory/index.jsx